export default __webpack_public_path__ + "static/media/clock_generator.e29bada7.svg";